import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import type {
  CardActivityListModel,
  CardActivityModel,
  CardActivityType,
} from '../models/card-details-api.models';
import { asArray, asNumber, asRecord, asString } from './card-api.utils';

@Injectable({ providedIn: 'root' })
export class CardActivitiesApiService {
  private readonly http = inject(HttpClient);

  async getByCard(cardId: string): Promise<CardActivityListModel> {
    const response = await firstValueFrom(this.http.get<unknown>(`/api/cards/${cardId}/activities`));
    const items = asArray(response)
      .map((entry) => this.mapActivity(entry, cardId))
      .filter((entry) => !!entry.id)
      .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
    return { items };
  }

  private mapActivity(raw: unknown, cardId: string): CardActivityModel {
    const source = asRecord(raw);
    return {
      id: asString(source['id']),
      cardId: asString(source['cardId']) || cardId,
      activityType: asNumber(source['activityType'], 1) as CardActivityType,
      description: asString(source['description']) || asString(source['message']),
      performedByUserId: asString(source['performedByUserId']) || null,
      createdAt: asString(source['createdAt']),
    };
  }
}
